// extracted by mini-css-extract-plugin
module.exports = {"container":"Reserve_container__1q1-D","header":"Reserve_header__1ZPyU","body":"Reserve_body__3GDHd","box":"Reserve_box__Zxh1W","loadcontainer":"Reserve_loadcontainer__146u-"};